export const DISMISS_ERROR = "DISMISS_ERROR";
export const DISMISS_ALL_ERRORS = "DISMISS_ALL_ERRORS";
export const HIDE_ERRORS = "HIDE_ERRORS";
export const SHOW_ERRORS = "SHOW_ERRORS";
export const NEW_ERROR = "NEW_ERROR";
